<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0 mx-0':'pr-0'">
  <div *ngIf="!isMobile" class="leftContentWidth my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyCoresNavNode'" [childNavState]="'SubmitCoreReturnNavNode'"
      [navState]="'MyCoresNavNode'"></app-my-account-left-sidenav>
  </div>
  <div [ngClass]="isMobile? 'totalWidth' :'righttContentWidth my-account-right-nav'">
    <ng-container>
      <div *ngIf="errorMsgList" class="form-upload-error">
        <ng-container *ngFor="let items of errorMsgList">
          <span>
            {{'common.text_coreimport_error_errorinline_message'|cxTranslate}} {{items.lineNumber}} : <span
              [innerHTML]="items.messageList[0].message|cxTranslate"></span>
            {{items.messageList[1].message|cxTranslate}}<br>
          </span>
        </ng-container>
        <ng-container *ngIf="fileUploadMsg">
          <br>
          <br>
          {{fileUploadMsg|cxTranslate}}
        </ng-container>
      </div>
      <div *ngIf="submittedSuccessFully" class="warranty-header-success-msg core-submit-msg">
        <div class="content">
          <span><strong>{{'common.text_core_submission_NA_text1'|cxTranslate}}</strong>
          <span class="msg-2"><a class="here"
              [routerLink]="['/search-coreReturn']" (click)="clickHere()">{{'common.text_core_submission_NA_text2a'|cxTranslate}}</a></span></span>
          <span class="msg-3" [innerHTML]="'common.text_core_submission_NA_text3'|cxTranslate"></span>
          <div class="d-flex success-msg-address">
            <span *ngIf="!mexicoDisable" class="left-msg" [innerHTML]="'common.text_core_submission_sucess_text1'|cxTranslate"></span>
            <span *ngIf="!mexicoDisable" [innerHTML]="'common.text_core_submission_sucess_text2'|cxTranslate"></span>
            <span *ngIf="mexicoDisable" [innerHTML]="'common.text_core_submission_sucess_text3'|cxTranslate"></span>
          </div>
        </div>
      </div>
      <div *ngIf="isFormContainsError" class="warranty-header-alert-msg mobile-visible " style="display: block;">
        <div class="content">
          <p>{{ 'common.form_global_error' | cxTranslate }}</p>
        </div>
      </div>
      <div *ngIf="isFormFilledSuccessfully && !submittedSuccessFully && !savedSuccessfully"
        class="warranty-header-warning-msg warning-alert-msg mobile-visible" style="display: block;">
        <div class="content">
          <p>{{ 'common.text_core_submission_review_text' | cxTranslate
            }}<br>{{'common.text_core_submission_thank_text'|cxTranslate}}</p>
        </div>
      </div>
      <div *ngIf="savedSuccessfully" class="warranty-header-warning-msg warning-alert-msg mobile-visible"
        style="display: block;">
        <div class="content">
          <p>{{'common.text_core_save_form_text'|cxTranslate}}<a class="linkclick" [routerLink]="['/CoreInfoCenter']"
              (click)="redirectCoreGroup()">&nbsp;{{'common.here'|cxTranslate}}</a></p>
        </div>
      </div>
    </ng-container>

    <form [formGroup]="coreReturnRequest">
      <div *ngIf="apiloaded">
        <div class="SubmitCoreReturnrequest col-xs-12 col-sm-12 col-md-12 p-0" [ngClass]="isMobile? 'px-0 mx-0':'pr-0'">
          <div class="SubmitCoreReturn w-100">

            <h1 class="coreReturnRequest m-0">{{'common.text_core_submission_return'|cxTranslate}}</h1>
            <div class="coreBold">
              <p><strong>{{'common.text_core_submission_pleaseNote'|cxTranslate}}</strong></p>
            </div>
            <div class="paragraphdiv">
              <p [innerHTML]="'common.text_core_submission_headerNA_text1'|cxTranslate"></p>
              <div class="d-flex col-12 px-0">
                <div class="px-0" [ngClass]="submittedSuccessFully?'col-8':'col-12'">
                  <p>{{'common.text_core_submission_headerNA_text2'|cxTranslate}}
                    <a class="link-redirect"
                      (click)="redirectCoreGroup()"><u>{{'common.text_core_submission_pdfNA'|cxTranslate}}</u></a>
                    {{'common.text_core_submission_headerNA_text3'|cxTranslate}}
                  </p>
                </div>
                <div class="px-0" [class.col-4]="submittedSuccessFully">
                  <div class="barCodeImage" *ngIf="submittedSuccessFully">
                    <img [src]="baseUrl + barCodeLabel?.url" [alt]="barCodeLabel?.altText">
                  </div>
                </div>
              </div>
            </div>
            <div class="dateNameContainer">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="dateName">
                    <label for="date-value"
                      class="date mb-0">{{'common.text_account_orderHistory_page_sort_byDate'|cxTranslate}}</label><br><br>
                    <div class="dateTextbox">
                      <input class="form-control coreDate" style="height: 50px;" formControlName="coreDate" type="text"
                        value="04/17/2024"><br>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="nameText">
                    <label for="name" class="bendixBig mb-0">
                      {{'common.text_core_na_submit_crm'|cxTranslate}}</label><br>
                    <small>{{'common.text_core_submit_internalUseOnly'|cxTranslate}}</small>
                    <input style="height: 50px;" class="form-control coreDate" formControlName="customerCRNumber"
                      type="text" value=""><br>
                  </div>
                </div>
              </div>
            </div>
            <div class="returnReferencediv">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="returnMonth ">
                    <label for="month"
                      class="mb-0 mt-0 ">{{'common.text_core_submit_month'|cxTranslate}}</label><br><br>
                    <div class="returnMonthtext">
                      <input class="corereturnmonth" formControlName="coreReturnMonth" type="text" value="May">
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="refrenceNumber">
                    <label for="reference" class="mb-0 mt-0">
                      {{'common.text_core_submit_customercrm'|cxTranslate}}</label>
                    <br>
                    <small>{{'common.text_core_submit_internalTrackingNumber'|cxTranslate}}</small><br>
                    <input class="corereturnmonthenabled" formControlName="customerCRMNumber" type="text" value="">
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="transportNeeded">
              <div class="row mt">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="customerId" [ngClass]="{'disabled-dropdown':submittedSuccessFully}">
                    <div class=" mb-0 mt-2 " style="font-size: 20px;">
                      <label>
                        {{'common.text_warranty_submit_customer_id'|cxTranslate}}
                      </label>
                    </div>
                    <div class="selectbox " (click)="showChild = !showChild">
                      <input type=" text" class="selectTextBox" style="visibility: hidden; max-height: 3px !important;"
                        formControlName="soldToCode">
                      <ng-container *ngFor="let item of Apidata?.b2bUnitsWSListNa">
                        <div class="customerIDclass mt-0" *ngIf="coreForm.soldToCode.value == item.uid">
                          {{item.salesArea1}}&nbsp;|&nbsp;{{item.salesArea2|cxTranslate}}&nbsp;|&nbsp;{{item.salesArea3}}
                        </div>
                      </ng-container>
                    </div>
                    <ng-container *ngIf="showChild">
                      <app-customer-id-drop-down [customerId]="Apidata?.b2bUnitsWSListNa" [pageSource]="'warrantyClaim'"
                        (dataEvent)="receiveData($event)"></app-customer-id-drop-down>
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- pickupAddressProvided for maxico only start -->
                  <ng-container *ngIf="mexicoDisable">
                    <div class="companyAddress AutoAddrress mt-30">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="companyName">
                            <label for="company-Name">{{'common.address_companyName'|cxTranslate}}</label>
                            <div class="companyNametextbox">
                              <input class="company-text" formControlName="addressCompanySoldto" type="text">
                              <ng-container
                                *ngIf="coreReturnRequest.get('addressCompanySoldto').invalid && coreReturnRequest.get('addressCompanySoldto').touched">
                                <span class="text_danger_show_acc">
                                  {{'common.form_field_required'|cxTranslate}}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="address">
                            <label for="address-Name">{{'common.text_core_submit_address_address'|cxTranslate}}</label>
                            <div class="addresstextbox">
                              <input class="company-text" formControlName="addressSoldto" type="text">
                              <ng-container
                                *ngIf="coreReturnRequest.get('addressSoldto').invalid && coreReturnRequest.get('addressSoldto').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="addresscity AutoAddrress">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="address2">
                            <label for="address-Name">{{'common.text_core_submit_address_address2'|cxTranslate}}</label>
                            <div class="addresstextbox">
                              <input class="address-text" formControlName="address2Soldto" type="text">
                              <ng-container
                                *ngIf="coreReturnRequest.get('address2Soldto').invalid && coreReturnRequest.get('address2Soldto').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="city">
                            <label for="city-Name">{{'common.text_core_submit_address_city'|cxTranslate}}</label>
                            <div class="citytextbox">
                              <input class="address-text" formControlName="citySoldto" type="text">
                              <ng-container
                                *ngIf="coreReturnRequest.get('citySoldto').invalid && coreReturnRequest.get('citySoldto').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="postalcodestate AutoAddrress">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="postalCode">
                            <label for="postal-Name">{{'common.text_core_submit_address_zipCode'|cxTranslate}}</label>
                            <div class="postaltextbox">
                              <input class="postal-text" formControlName="zipCodeSoldto" type="text">
                              <ng-container
                                *ngIf="coreReturnRequest.get('zipCodeSoldto').invalid && coreReturnRequest.get('zipCodeSoldto').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="stateName">
                            <label for="state-Name">{{'common.text_core_submit_address_stateCode'|cxTranslate}}</label>
                            <div class="statetextbox">
                              <input class="postal-text" formControlName="stateSoldto" type="text">
                              <ng-container
                                *ngIf="coreReturnRequest.get('stateSoldto').invalid && coreReturnRequest.get('stateSoldto').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 AutoAddrress">
                      <div class="countryLabel">
                        <label for="country-label">{{'common.register_company_countryCode'|cxTranslate}}</label>
                        <div class="selectAddress newOneCountry">
                          <div class="select-box">
                            <select class="selectCountry" formControlName="countryISOSoldto">
                              <option value="null" disabled [selected]="coreReturnRequest.get('countryISOSoldto').value == null">
                                {{'common.form_register_empty'|cxTranslate}}</option>
                              <option [value]="item?.isocode" *ngFor="let item of countryDataArray">
                                {{item?.name}}
                              </option>
                            </select>
                          </div>
                          <ng-container
                            *ngIf="coreReturnRequest.get('countryISOSoldto').invalid && coreReturnRequest.get('countryISOSoldto').touched">
                            <div>
                              <span class="text_danger_show_acc">
                                {{'common.form_field_required'|cxTranslate}}
                              </span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                     <!-- pickupAddressProvided for maxico only end -->
              <div class="firstlastname">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="firstName"><br>
                      <label for="first-Name">{{'common.text_core_submit_firstName'|cxTranslate}}</label>
                      <div class="firstNametextbox ">
                        <input class="name-text classDisabled" formControlName="firstName" type=" text" value=" ">
                      </div>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="lastName"><br>
                      <label for="last-Name">{{'common.text_core_submit_lastName'|cxTranslate}}</label>
                      <div class="lastNametextbox ">
                        <input class="name-text classDisabled" formControlName="lastName" type="text" value=" ">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="phoneMail">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="phoneNumber"><br>
                      <label for="phone">{{'common.text_core_submit_phone'|cxTranslate}}</label><span
                        *ngIf="!mexicoDisable">*</span>
                      <div class="phoneTextbox">
                        <input class="phonenumbertext" formControlName="phone" type="number" value="">
                        <ng-container
                          *ngIf="coreReturnRequest.get('phone').invalid && coreReturnRequest.get('phone').touched ">
                          <span class="text_danger_show_acc">
                            {{'common.form_field_required'|cxTranslate}}
                          </span>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="emailId"><br>
                      <label for="email">{{'common.text_core_submit_emailAddress'|cxTranslate}}</label>
                      <div class="emailTextbox">
                        <input [ngClass]="mexicoDisable?'classDisabled phonenumbertext':'phonenumbertext'"
                          formControlName="emailAddress" type="email" value="">
                        <ng-container
                          *ngIf="coreReturnRequest.get('emailAddress').invalid && coreReturnRequest.get('emailAddress').touched ">
                          <span class="text_danger_show_acc">
                            {{'common.form_field_required'|cxTranslate}}
                          </span>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="!mexicoDisable">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="warrantyMaterialclass">
                    <div class="checkbox">
                      <label for="kbTransport2"><br>
                        <input class="warrantycheckbox" formControlName="warrantyMaterial" type="checkbox"
                          [value]="false" (click)="toggleTextBox()">
                        {{'common.core_submit_warranty_material_included'|cxTranslate}}
                        <span class="skip"></span>
                        <span class="checkmark"></span>
                      </label>
                      <br>
                      <span class="warranty-material">{{'common.text_core_submission_clarify'|cxTranslate}}</span>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="showTextBox">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="warrantyMaterialclass mg" id="warrantyClaimContainer"><br>
                      <label
                        class="checkboxlabel">{{'common.text_account_warranty_search_page_sort_byOrderNumber'|cxTranslate}}</label>
                      <input class="warrantyClaim" formControlName="warrantyClaimNo" type="text" value="">
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="row " *ngIf="!mexicoDisable" [class.crmDisabler]="UserCrmForm">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="kb-radio"><br><br>
                    <input class="kbTransport1button" type="radio" formControlName="kbTransport"
                      (change)="underRadio500lbs()" [value]="'true'">
                    <label class="kbTransport1" [innerHTML]="'common.na_core_over500lbs_msg'|cxTranslate"></label>
                  </div>
                  <div class="kb-radio">
                    <input class="kbTransport2button" formControlName="kbTransport" type="radio"
                      (change)="underRadio500lbs()" [value]="'false'">
                    <label class="kbTransport2" [innerHTML]="'common.na_core_under500lbs_msg'|cxTranslate"></label>
                  </div>
                </div>
              </div>
              <br>
              <br>
              <div formGroupName="kbCoreSubmissionAddressForm" class="bgCoverdiv" *ngIf="!mexicoDisable">
                <ng-container *ngIf="!notDisplay">
                  <div class="row">
                    <div class="col-md-12 pickAddress">{{'common.text_pickup_address'|cxTranslate}}</div>
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <label for="address-label">{{'common.select_pickup_address'|cxTranslate}}</label>
                      <div class="selectAddress select-box core-select-box">
                        <select class=" selectimg" formControlName="b2BUnit" (change)="autoGenerate()">
                          <option value="null" [selected]="nestedForm.get('b2BUnit').value==null" disabled>
                            {{'common.form_select_empty'|cxTranslate}}</option>
                          <option [value]="item.pk" *ngFor="let item of addressListArray">
                            {{item.sapCustomerID}}&nbsp;|&nbsp;{{item.companyName}}&nbsp;|&nbsp;{{item.formattedAddress}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <label for="pickupAddress"><br>{{'common.text_core_submission_address_na'|cxTranslate}}</label>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 core-slm-wrapper pr-3">
                      <div class="checkbox">
                        <label for="addAddress">
                          <input formControlName="newAddress" class="addAddresscheckbox"
                            type="checkbox">
                          {{'common.address_add_new_msg'|cxTranslate}}
                        </label>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="nestedForm.get('newAddress').value==false">
                    <div class="companyAddress AutoAddrress">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="companyName">
                            <label for="company-Name">{{'common.address_companyName'|cxTranslate}}</label>
                            <div class="companyNametextbox">
                              <input class="company-text" formControlName="addressCompany" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('addressCompany').invalid && nestedFormGroup.get('addressCompany').touched">
                                <span class="text_danger_show_acc">
                                  {{'common.form_field_required'|cxTranslate}}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="address">
                            <label for="address-Name">{{'common.text_core_submit_address_address'|cxTranslate}}</label>
                            <div class="addresstextbox">
                              <input class="company-text" formControlName="address" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('address').invalid && nestedFormGroup.get('address').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="addresscity AutoAddrress">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="address2">
                            <label for="address-Name">{{'common.text_core_submit_address_address2'|cxTranslate}}</label>
                            <div class="addresstextbox">
                              <input class="address-text" formControlName="address2" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('address2').invalid && nestedFormGroup.get('address2').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="city">
                            <label for="city-Name">{{'common.text_core_submit_address_city'|cxTranslate}}</label>
                            <div class="citytextbox">
                              <input class="address-text" formControlName="city" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('city').invalid && nestedFormGroup.get('city').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="postalcodestate AutoAddrress">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="postalCode">
                            <label for="postal-Name">{{'common.text_core_submit_address_zipCode'|cxTranslate}}</label>
                            <div class="postaltextbox">
                              <input class="postal-text" formControlName="zipCode" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('zipCode').invalid && nestedFormGroup.get('zipCode').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="stateName">
                            <label for="state-Name">{{'common.text_core_submit_address_stateCode'|cxTranslate}}</label>
                            <div class="statetextbox">
                              <input class="postal-text" formControlName="state" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('state').invalid && nestedFormGroup.get('state').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 AutoAddrress">
                      <div class="countryLabel">
                        <label for="country-label">{{'common.register_company_countryCode'|cxTranslate}}</label>
                        <div class="selectAddress newOneCountry">
                          <div class="select-box">
                            <select class="selectCountry" formControlName="countryISO">
                              <option value="null" disabled [selected]="nestedForm.get('countryISO').value == null">
                                {{'common.form_register_empty'|cxTranslate}}</option>
                              <option [value]="item?.isocode" *ngFor="let item of countryDataArray">
                                {{item?.name}}
                              </option>
                            </select>
                          </div>
                          <ng-container
                            *ngIf="nestedFormGroup.get('countryISO').invalid && nestedFormGroup.get('countryISO').touched">
                            <div>
                              <span class="text_danger_show_acc">
                                {{'common.form_field_required'|cxTranslate}}
                              </span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <!-- New Address  -->
                  <ng-container *ngIf="nestedForm.get('newAddress').value==true">
                    <div class="companyAddress">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="companyName">
                            <label for="company-Name">{{'common.address_companyName'|cxTranslate}}</label>
                            <div class="companyNametextbox">
                              <input class="company-text" formControlName="addressCompanyNew" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('addressCompanyNew').invalid && nestedFormGroup.get('addressCompanyNew').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="address">
                            <label for="address-Name">{{'common.text_core_submit_address_address'|cxTranslate}}</label>
                            <div class="addresstextbox">
                              <input class="company-text" formControlName="addressNew" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('addressNew').invalid && nestedFormGroup.get('addressNew').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="addresscity">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="address2">
                            <label for="address-Name">{{'common.text_core_submit_address_address2'|cxTranslate}}</label>
                            <div class="addresstextbox">
                              <input class="address-text" formControlName="address2New" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('address2New').invalid && nestedFormGroup.get('address2New').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="city">
                            <label for="city-Name">{{'common.text_core_submit_address_city'|cxTranslate}}</label>
                            <div class="citytextbox">
                              <input class="address-text" formControlName="cityNew" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('cityNew').invalid && nestedFormGroup.get('cityNew').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="postalcodestate">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="postalCode">
                            <label for="postal-Name">{{'common.text_core_submit_address_zipCode'|cxTranslate}}</label>
                            <div class="postaltextbox">
                              <input class="postal-text" formControlName="zipCodeNew" type="text">
                              <ng-container
                                *ngIf="nestedFormGroup.get('zipCodeNew').invalid && nestedFormGroup.get('zipCodeNew').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="stateName">
                            <label for="state-Name">{{'common.text_core_submit_address_stateCode'|cxTranslate}}</label>
                            <div class="statetextbox">
                              <div class="selectChecker">
                                <select formControlName="townNew">
                                  <option value="null" disabled [selected]="nestedForm.get('townNew').value == null">
                                    {{'common.form_select_empty'|cxTranslate}}</option>
                                  <option [value]="item?.name" *ngFor="let item of stateDataArray">
                                    {{item?.name}}
                                  </option>
                                </select>
                              </div>
                              <ng-container
                                *ngIf="nestedFormGroup.get('townNew').invalid && nestedFormGroup.get('townNew').touched">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      <div class="countryLabel">
                        <label for="country-label">{{'common.register_company_countryCode'|cxTranslate}}</label>
                        <div class="selectChecker ">
                          <select formControlName="countryISONew" (change)="getStatelist()">
                            <option value="null" disabled [selected]="nestedForm.get('countryISONew').value == null">
                              {{'common.form_register_empty'|cxTranslate}}</option>
                            <option [value]="item?.isocode" *ngFor="let item of countryDataArray">
                              {{item?.name}}
                            </option>
                          </select>
                          <ng-container
                            *ngIf="nestedFormGroup.get('countryISONew').invalid && nestedFormGroup.get('countryISONew').touched">
                            <div>
                              <span class="text_danger_show_acc">
                                {{'common.form_field_required'|cxTranslate}}
                              </span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="col-xs-12 col-sm-12 col-md-12 mt-4 mb-4 ml-4 submit-core-subTitle">
                    <label>{{'common.pickup_address_provided'|cxTranslate}}</label>
                  </div>
                  <div class="firstlastname mt-3">
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="firstName form-group">
                          <label for="first-Name">{{'common.text_core_submit_firstName'|cxTranslate}}</label>
                          <div class="firstNametextbox">
                            <input class="name-textbox form-control" formControlName="addressFName" type="text"
                              value=" ">
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="lastName form-group">
                          <label for="last-Name">{{'common.text_core_submit_lastName'|cxTranslate}}</label>
                          <div class="lastNametextbox">
                            <input class="name-textbox form-congrol" formControlName="addressLName" type="text"
                              value=" ">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="phoneMail">
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="phoneNumber form-group">
                          <label for="phone">{{'common.text_core_submit_address_addressPhone'|cxTranslate}}</label>
                          <div class="phoneTextbox">
                            <input class="phonenumbertextbox form-control" formControlName="addressPhone" type="text"
                              value="">
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="emailId form-group">
                          <label for="email">{{'common.text_core_submit_address_addressEmail'|cxTranslate}}</label>
                          <div class="emailTextbox">
                            <input class="phonenumbertextbox form-control" formControlName="addressEmail" type="text"
                              value="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="showUnder500">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 mt-4 core-submitproducttype"
                    [class.crmDisabler]="UserCrmForm">
                    <div class="productType"><label for="pleaseselect"
                        class="f-s please-select-lbl">{{'common.text_core_submission_product'|cxTranslate}}</label>
                    </div>
                    <div class="select-box core-production-type mb-10">
                      <select class="pleaseselect selectimg" formControlName="productType">
                        <option value="null" [selected]="nestedForm.get('productType').value == null" disabled>
                          {{'common.form_select_empty'|cxTranslate}}</option>
                        <option [value]="item.key" *ngFor="let item of productTypeArray">{{item.value}}</option>
                      </select>
                      <ng-container
                        *ngIf="nestedFormGroup.get('productType').invalid && nestedFormGroup.get('productType').touched">
                        <div>
                          <span class="text_danger_show_acc ml">
                            {{'common.form_field_required'|cxTranslate}}
                          </span>
                        </div>`
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <div class="row" *ngIf="!mexicoDisable">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4"
                    [ngClass]="{'disabled-dropdown':submittedSuccessFully}">
                    <a [href]="downLoadUrl" class="btn btn-primary buttonchoose downloadTemplate" target="_blank">
                      {{'common.import_csv_core_downloadTemplate'|cxTranslate}}
                      <img class="img-hover" src="/icons/link-grey.svg" width="20px" alt="Link Icon">
                    </a>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                    <button class="btn btn-primary buttonchoose" [disabled]="submittedSuccessFully">
                      {{'common.import_csv_savedCart_chooseFile'|cxTranslate}}
                      <img class="img-hover" src="/icons/link-grey.svg" width="20px" alt="Link Icon">
                    </button>
                    <input type="file" class="fileSelectDisable" #fileInput (input)="onFileChange($event)">
                  </div>
                  <div class=" col-xs-12 col-sm-12 col-md-12 col-lg-5 mb-3 mt">
                    <p class="core-csv-text">{{'common.text_core_form_csvMessage1'|cxTranslate}} &nbsp;
                      <button placement="bottom" class="BAFtooltip" [tooltip]="coretemplate"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Core Submit">
                      </button>
                    </p>
                    <ng-template #coretemplate>
                      <span [innerHTML]="'common.text_core_csv_infoTip_text'|cxTranslate"></span>
                    </ng-template>
                    <div class="core-csv-text-msg2" [innerHTML]="'common.text_core_form_csvMessage2'|cxTranslate">
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class=" cart-list-item-wrapper mt-lg-0 mob_padd">
            <div class="col-12 mobile-delete-wrapper delete_btn_root">
              <div>
                <p *ngIf="mexicoDisable">{{'common.Enter_your_part_number_using_the_magnifying_glass_below'|cxTranslate}}</p>
              </div>
              <button class="cart-delete-selected  delete_btn_u"
                (click)="removeSelectedRows()">{{'common.general_delete_all_button'|cxTranslate}}</button>
            </div>
            <div class="col-12 mt-2 p-0 cart-details-section">
              <div class="table-responsive">
                <table class="table table-bordered border_BottomDown">
                  <thead>
                    <tr class="d-none d-lg-table-row common_row">
                      <td class="core-group">
                        {{'common.text_coreGroup'|cxTranslate}}</td>
                      <td class="core-class">
                        {{'common.text_core_submit_coreClass'|cxTranslate}}</td>
                      <td class="core-grade">
                        {{'common.text_core_submission_coregrade'|cxTranslate}}</td>
                      <td class="core-grade" *ngIf="mexicoDisable">
                        {{'common.text_core_part_number'|cxTranslate}}</td>
                      <td class="core-grade">{{'common.text_quickOrder_page_qty'|cxTranslate}}</td>
                      <td class="core-upgrade">{{'common.text_core_submission_upgrade'|cxTranslate}}</td>
                      <td class="core-upgrade-class">
                        {{'common.text_core_submission_upgradegrp'|cxTranslate}}</td>
                      <td class="core-upgrade-class">
                        {{'common.text_core_submission_wghtApx'|cxTranslate}}{{'common.text_core_submission_wghtCode'|cxTranslate}}
                      </td>
                      <td class="core-upgrade-class">
                        {{'common.text_core_submission_wghttotal'|cxTranslate}}{{'common.text_core_submission_wghtCode'|cxTranslate}}
                      </td>
                      <td class="select-all-check">
                        <span class="custom-checkbox">
                          <input id="remove_cart-all" name="removecart" (change)="selectAllRows($event)"
                            class="cart-checkbox" type="checkbox">
                          <label for="remove_cart-all"></label>
                        </span>
                      </td>
                    </tr>
                  </thead>

                  <ng-container formArrayName="coreLineItems">
                    <ng-container *ngFor="let partInfoControls of dtf.controls; let i=index">
                      <ng-container [formGroupName]="i">
                        <tbody class="table-content ">
                          <tr class="cart-for-mobile no-border ">
                            <td class="tbody_class no-border">
                              <div class="col-12 col-sm-12 col-md-12 core-SubmitLabel"><span
                                  class="core-submit-pl">{{'common.text_core_submit_coreGroup'|cxTranslate}}</span>
                              </div>
                              <div class="core-submit-coreGroup">
                                <span class="search_icon" (click)="openPopups(i)"></span>
                                <div class="d-flex flex-column core-SearchSelect">
                                  <div class="select-box core-production-type">
                                    <select class="form-control down_icon_group selectimg d-flex "
                                      formControlName="coreGroup" id="cart-order-type" #dropdown
                                      (change)="getCoreClass(i)" [ngClass]="{ 'readonly-select': mexicoDisable}">
                                      <option value="null" [selected]="getcoreLineEMEAControls(i,'coreGroup')== null"
                                        disabled>
                                        {{'common.please_select_state_text'|cxTranslate}}</option>
                                      <option [value]="item.key" *ngFor="let item of Apidata?.coreGroupsNa?.entry">
                                        {{item.key}}&nbsp;&nbsp;{{item.value}}
                                      </option>
                                    </select>
                                  </div>
                                  <ng-container
                                    *ngIf="getcoreLineEMEAControls(i,'coreGroup').invalid && getcoreLineEMEAControls(i,'coreGroup').touched ">
                                    <div>
                                      <span class="text_danger_show_acc ">
                                        {{'common.form_field_required'|cxTranslate}}
                                      </span>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </td>
                            <td class="tbody_class no-border">
                              <div class="d-flex flex-column">
                                <span
                                  class="core-SubmitLabel">{{'common.text_core_submit_coreClass'|cxTranslate}}</span>
                                <div class="select-box core-production-type">
                                  <select class="form-control down_icon_class selectimg" formControlName="coreClass"
                                    (change)="getWeightNa(i);getUpgradeCoreClass(i)" [ngClass]="{ 'readonly-select': mexicoDisable}">
                                    <option value="null" [selected]="getcoreLineEMEAControls(i,'coreClass')" disabled>
                                      {{'common.please_select_state_text'|cxTranslate}}</option>
                                    <option [value]="item.key" *ngFor="let item of coreClass[i]">{{item.key}}
                                      {{item.value}}
                                    </option>
                                  </select>
                                </div>
                                <ng-container
                                  *ngIf="getcoreLineEMEAControls(i,'coreClass').invalid && getcoreLineEMEAControls(i,'coreClass').touched ">
                                  <div>
                                    <span class="text_danger_show_acc">
                                      {{'common.form_field_required'|cxTranslate}}
                                    </span>
                                  </div>
                                </ng-container>
                              </div>
                            </td>

                            <td class="tbody_grade no-border">
                              <div class="d-flex flex-column">
                                <span class="core-SubmitLabel">
                                  {{'common.text_core_submission_coregrade'|cxTranslate}}</span>
                                <div class="select-box core-production-type">
                                  <select class="form-control down_icon_grade selectimg" formControlName="coreGrade">
                                    <option value="null" disabled
                                      [selected]="getcoreLineEMEAControls(i,'coreGrade').value == null">
                                      {{'common.please_select_state_text'|cxTranslate}}</option>
                                    <option [value]="item.key" *ngFor="let item of Apidata?.coreGrade?.entry">
                                      {{item.value}}
                                    </option>
                                  </select>
                                </div>
                                <ng-container
                                  *ngIf="getcoreLineEMEAControls(i,'coreGrade').invalid && getcoreLineEMEAControls(i,'coreGrade').touched ">
                                  <div>
                                    <span class="text_danger_show_acc">
                                      {{'common.form_field_required'|cxTranslate}}
                                    </span>
                                  </div>
                                </ng-container>
                              </div>
                            </td>
                            <td class="tbody_weight_approx no-border" *ngIf="mexicoDisable">
                              <span class="core-SubmitLabel">{{'common.text_core_part_number'|cxTranslate}}</span>
                              <input type="text" class="form-control down_icon_qty" formControlName="corePartNumber" />
                            </td>
                            <td class="tbody_qty no-border">
                              <span class="core-SubmitLabel">{{'common.text_quickOrder_page_qty'|cxTranslate}}</span>
                              <input type="text" class="form-control down_icon_qty" (keydown)="onKeyDown($event)"
                                (input)="weightCalculator(i, $event)" formControlName="itemQty" />
                              <ng-container
                                *ngIf="getcoreLineEMEAControls(i,'itemQty').invalid && getcoreLineEMEAControls(i,'itemQty').touched ">
                                <div>
                                  <span class="text_danger_show_acc">
                                    {{'common.form_field_required'|cxTranslate}}
                                  </span>
                                </div>
                              </ng-container>
                            </td>

                            <td class="tbody_upgrade no-border">
                              <span
                                class="core-SubmitLabel">{{'common.text_core_submission_upgrade'|cxTranslate}}</span>
                              <span class="custom_align_checkbox">
                                <input type="checkbox" (change)="upgradeCheckbox(i)" class="upgrader_core"
                                  formControlName="submissionUpgrade">
                                <label for="remove_cart"></label>
                              </span>
                            </td>
                            <td class="tbody_core_upgrade no-border">
                              <span
                                class="core-SubmitLabel">{{'common.text_core_submission_upgradegrp'|cxTranslate}}</span>
                              <div class="select-box core-production-type">
                                <select class="form-control down_icon_core_upgrade selectimg"
                                  formControlName="updateCoreGroup">
                                  <option value="null" [selected]="dtf.get('updateCoreGroup')== null">
                                    {{'common.please_select_state_text'|cxTranslate}}</option>
                                  <option [value]="item.key" *ngFor="let item of coreUpgradeClass[i]">
                                    {{item.value}}
                                  </option>
                                </select>
                              </div>
                            </td>
                            <td class="tbody_weight_approx no-border">
                              <span
                                class="core-SubmitLabel">{{'common.text_core_submission_wghtApx'|cxTranslate}}{{'common.text_core_submission_wghtCode'|cxTranslate}}</span>
                              <input type="text" class="form-control down_weight_approx"
                                formControlName="weightAprox" />
                            </td>
                            <td class="tbody_weight_total no-border">
                              <span
                                class="core-SubmitLabel">{{'common.text_core_submission_wghttotal'|cxTranslate}}{{'common.text_core_submission_wghtCode'|cxTranslate}}
                              </span>
                              <input type="text" class="form-control down_weight_total" value="0"
                                formControlName="itemWeight" />
                             
                            </td>
                            <td class="final_check no-border">
                              <div class="checkbox_final  align-items-center remove-mobile">
                                <span class="delete_checkbox">
                                  <input class="delete_core" type="checkbox" formControlName="deletecheckbox">
                                </span>
                                &emsp;&emsp;
                                <span class="remove-item remove_check" (click)="removeField(i)"></span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </table>
              </div>
            </div>
            <div class="col-lg-3 col-sm-12 buttonContainer_one">
              <button class=" btn btn-block button-launch" [disabled]="submittedSuccessFully"
                (click)="addPartNumber()">{{'common.text_add_row_button'|cxTranslate}}</button>
            </div>

            <ng-container *ngIf="coreReturnRequest && mexicoDisable" formArrayName="coreAddInvoiceNumber">
              <div class="col-lg-9 col-sm-12 mt-2 invoice_number_section d-flex align-items-center" *ngFor="let group of invoiceControls; let j = index" [formGroupName]="j">

                <label for="invoiceNumber" class="invoice_number_label white-space-nowrap">{{'common.text_core_submission_invoiceNumber'|cxTranslate}} :</label>
                <div class="input-group">
                  <input type="text" formControlName="invoiceNumber" class="form-control invoice_number_input"
                    placeholder="{{'common.text_core_submission_invoiceNumber'|cxTranslate}}" aria-label="Invoice Number"
                    aria-describedby="basic-addon2">
                  <div class="input-group-append">
                    <button class="btn btn-block button-invoice" type="button"
                      (click)="addInvoiceField()">{{'common.text_core_new_invoiceNumber'|cxTranslate}}</button>
                  </div>
                </div>
              </div>
            </ng-container>


            <div class="col-12 mt-5 p-0 cart-details-section">
              <div class="table-responsive">
                <table class="table table-bordered mb-0 ">
                  <thead>
                    <tr class="d-none d-lg-table-row">
                      <td class="core_empty_one"></td>
                      <td class="core_empty_one"></td>
                      <td class="core_total">{{'common.basket_page_totals_total'|cxTranslate}}</td>
                      <td class="core_zero">
                        <input type="number" class="theaderinput" placeholder=" 0" formControlName="totalQty">
                      </td>
                      <td class="core_empty_two"></td>
                      <td class="core_empty_three"></td>
                      <td class="core_empty_two"></td>
                      <td class="core_zero_zero"><input type="number" class="theaderinput" placeholder=" 0.0"
                          formControlName="totalWeight"></td>
                    </tr>
                  </thead>
                </table>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class=" core_tbody">
                    <div class="core-body-tooltip-button">
                      <span class="pallet">
                        <p> <strong>{{'common.text_actual_weight'|cxTranslate}}</strong></p>
                      </span>
                      <ng-template #weighttemplate>
                        <span [innerHTML]="'common.text_tooltip_actual_weight'|cxTranslate"></span>
                      </ng-template>
                      <button placement="bottom" class="BAFtooltip" [tooltip]="weighttemplate"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Core Submit">
                      </button>
                    </div>
                    <span class="pallet core-actual-weight">
                      <input type="text" formControlName="actualWeight" class="form-control down_icon_qty" />
                    </span>
                    <div class="core-body-tooltip-button">
                      <span class="pallet">
                        <p><strong>{{'common.text_core_submission_package'|cxTranslate}}</strong></p>
                      </span>
                      <ng-template #pallettemplate>
                        <span [innerHTML]="'common.text_tooltip_package_type'|cxTranslate"></span>
                      </ng-template>
                      <button placement="bottom" class="BAFtooltip" [tooltip]="pallettemplate"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Core Submit">
                      </button>
                    </div>
                    <span class="pallet">
                      <div class="select-box core-production-type">
                        <select class="form-control selectimg" formControlName="packageType">
                          <option value="null" [selected]="coreForm.packageType== null">
                            {{'common.please_select_state_text'|cxTranslate}}</option>
                              <!-- When mexicoDisable === false -->
                              <ng-container *ngIf="!mexicoDisable">
                                <ng-container *ngFor="let item of Apidata.packaging.entry">
                                  <option
                                    *ngIf="item.key === 'PALLET' && showUnder500"
                                    [value]="item.key">
                                    {{ item.value }}
                                  </option>

                                  <option
                                    *ngIf="item.key === 'BOX' && !showUnder500"
                                    [value]="item.key">
                                    {{ item.value }}
                                  </option>
                                </ng-container>
                              </ng-container>

                              <!-- When mexicoDisable === true -->
                              <ng-container *ngIf="mexicoDisable">
                                <ng-container *ngFor="let item of Apidata.packaging.entry">
                                  <option
                                    *ngIf="item.key === 'BOX' || item.key === 'PALLET'"
                                    [value]="item.key">
                                    {{ item.value }}
                                  </option>
                                </ng-container>
                              </ng-container>
                            </select>
                      </div>
                    </span>
                    <span class="pallet pallet-qty-label">
                      <p *ngIf="showUnder500"><strong>{{'common.text_core_submission_palletQty'|cxTranslate}}</strong>
                      </p>
                      <p *ngIf="!showUnder500"><strong>{{'common.text_core_submission_BoxQty'|cxTranslate}}</strong></p>

                    </span>
                    <span class="pallet">
                      <input type="text" formControlName="packageQty" class="form-control down_icon_qty" />
                      <ng-container
                        *ngIf="coreReturnRequest.get('packageQty').invalid && coreReturnRequest.get('packageQty').touched ">
                        <div>
                          <span class="text_danger_show_acc">
                            {{'common.form_field_required'|cxTranslate}}
                          </span>
                        </div>
                      </ng-container>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mt-5">
              <div class="d-none d-md-none d-lg-block col-lg-4"></div>
              <div class="col-lg-8 col-md-12 buttonContainer_two ">
                <button class="btn btn-primary btn_core" [disabled]="!isFormFilledSuccessfully || submittedSuccessFully"
                  (click)="saveforlater()">{{'common.text_company_save_later_button'|cxTranslate}}&nbsp;&nbsp;
                  <img class="img-hover" src="/icons/link-grey.svg" width="20px" /></button>&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp; <button class="btn btn-blue" [disabled]="submittedSuccessFully"
                  (click)="finalReview()">{{'common.checkout_summary_reviewYourOrder'|cxTranslate}}</button>&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;
                <button class="btn btn-primary btn_core" [disabled]="!isFormFilledSuccessfully || submittedSuccessFully"
                  (click)="mexicoDisable ? onSubmit() : openPopup()">{{'common.text_warranty_submit_button'|cxTranslate}}&nbsp;&nbsp;
                  <img class="img-hover" src="/icons/link-grey.svg" width="20px" />
                </button>
              </div>
            </div>
            <div class="d-flex mt-1 ml-3" *ngIf="coreReturnRequest?.get('soldToCode')?.value?.includes('0315')">
              <input class="agrees_To_Terms_Checkbox" type="checkbox" name="certifycheck"
                formControlName="certifycheck">
              <span>{{'common.core_submit_warranty_certify_check'|cxTranslate}}</span>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

</div>

<ng-template #confirmSubmitPopup>
  <div class="popupComponent">
    <div class="imageClose" mat-dialog-close>
      <img width="20px" src="/icons/close-kb.svg ">
    </div>
    <div class="textDiv">
      <p>
        <b> {{'common.text_anotherCR_sameBOL'|cxTranslate}}</b>
      </p>
      <p [innerHTML]="'common.text_No_sameBOL_if_not_combining_cr'|cxTranslate">
      </p>
      <div class="buttonDiv">
        <button class="btn btn-primary createBtn" mat-dialog-close
          (click)="createForm()">{{'common.text_create_label'|cxTranslate}}</button>
        <button class="btn btn-primary submitBtn" mat-dialog-close
          (click)="onSubmit()">{{'common.mobile_checkout_multi_button_submit'|cxTranslate}}</button>
      </div>
    </div>

  </div>
</ng-template>